import { Cancel, Send } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import SendIcon from "@mui/icons-material/Send";
import ViewStreamIcon from "@mui/icons-material/ViewStream";
import {
  Box,
  Button,
  Chip,
  Fab,
  Grid,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import moment from "moment";
import React, { useEffect, useState, useContext } from "react";
import AuthContext from "../auth/AuthProvider";
import { toast } from "sonner";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import "../card.css";
import Header from "../components/Header";
import { useLocation } from 'react-router-dom';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import FolderSharedRoundedIcon from "@mui/icons-material/FolderSharedRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  borderRadius: "10px",
}));

const Iteme = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
}));


const Expenses = (isOnline) => {
  const location = useLocation();
  const society_id = location.state && location.state.society_id;
  const society_name = location.state && location.state.name;
  const [requestExpenseList, setRequestExpenseList] = useState([]);
  const [reg_amount_sum, setReg_amount_sum] = useState([]);
  const [reg_balance_sum, setReg_balance_sum] = useState([]);
  const [recommendedExpenseList, setRecommendedExpenseList] = useState([]);
  const [rec_amount_sum, setRec_amount_sum] = useState([]);
  const [rec_balance_sum, setRec_balance_sum] = useState([]);
  const [approveExpenseList, setApproveExpenseList] = useState([]);
  const [apr_amount_sum, setApr_amount_sum] = useState([]);
  const [apr_balance_sum, setApr_balance_sum] = useState([]);
  const [rejectExpenseList, setRejectExpenseList] = useState([]);
  const [rej_amount_sum, setRej_amount_sum] = useState([]);
  const [rej_balance_sum, setRej_balance_sum] = useState([]);
  const [disburseExpenseList, setDisburseExpenseList] = useState([]);
  const [dis_amount_sum, setDis_amount_sum] = useState([]);
  const [dis_balance_sum, setDis_balance_sum] = useState([]);
  const [openn, setOpenn] = useState(false);
  const [ecash, setEcash] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [start_date_req, setStart_date_req] = useState("");
  const [end_date_req, setEnd_date_req] = useState("");
  const [start_date_rec, setStart_date_rec] = useState("");
  const [end_date_rec, setEnd_date_rec] = useState("");
  const [start_date_apr, setStart_date_apr] = useState("");
  const [end_date_apr, setEnd_date_apr] = useState("");
  const [start_date_dis, setStart_date_dis] = useState("");
  const [end_date_dis, setEnd_date_dis] = useState("");
  const [start_date_rej, setStart_date_rej] = useState("");
  const [end_date_rej, setEnd_date_rej] = useState("");
  const [soc, setSoc] = useState();
  const [idd, setIdd] = useState();
  const [nowAmount, setNowAmount] = useState();
  const [transferDetails, setTransferDetails] = useState([]);
  const [account_idd, setAccount_idd] = useState();
  const [see, setSee] = useState(true);
  const [note, setNote] = useState(false);
  const [amountt, setAmountt] = useState();
  const [reco_amount, setReco_amount] = useState(null);
  const [ledger_name, setledger_name] = useState("");
  const [naration, setNaration] = useState("");
  const [actionMessage, setActionMessage] = useState("");
  const [recom, setRecom] = useState("");
  const { permissions } = useContext(AuthContext);
  const [newDate, setNewDate] = useState("");
  const [openDate, setOpenDate] = useState(false);
  const [hold_id, sethold_id] = useState(null);
  const [disbures_date, setDisbures_date] = useState("");
  

  const changeDate  = (id) => {
    setOpenDate(true)
    sethold_id(id)
  }

  const closeDate = () => {
    setOpenDate(false)
    sethold_id(null)
    setNewDate("")
  }

  const editDisbureseDate = () => {
    const data = new FormData()
    data.append("id", hold_id)
    data.append("date", newDate)

    toast.promise(
      api
      .post(
        '/account/edit/disbures/date', data,
        {
          headers: {
            Authorization: "Bearer " + fetchToken(),
            "Content-Type": "multipart/form-data",
          },
        }
      ),
      {
          loading: 'Updating account...',
          success: (response) => {
            closeDate();
            fetchExpenses();
            return response.data
          },
          error: (error) => {
              console.log(error);
              
              return 'Error, Please try again'
          }
      }
    )
  }
   

  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    maxHeight: "80vh",
    minHeight: "70vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const fetch_somthing = () => {
    const cachedSoc = localStorage.getItem("userSociety");

    if (cachedSoc) {
      setSoc(JSON.parse(cachedSoc));
    } else {
      api
        .get("/users/user/society", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setSoc(response.data?.Soc);

          localStorage.setItem(
            "userSociety",
            JSON.stringify(response.data?.Soc)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }



  useEffect(() => {
    fetch_somthing();
    handleSocietyBanks();
  }, []);

  const fetchExpenses = async () => {
    const localData = localStorage.getItem("expensesData");

    if (!isOnline) {
      const parsedData = JSON.parse(localData);
      setRequestExpenseList(parsedData.Requested_Expenses);
      setReg_amount_sum(parsedData.reg_amount_sum);
      setReg_balance_sum(parsedData.reg_balance_sum);
      setRecommendedExpenseList(parsedData.Recommended_Expenses);
      setRec_amount_sum(parsedData.rec_amount_sum);
      setRec_balance_sum(parsedData.rec_balance_sum);
      setApproveExpenseList(parsedData.Approved_Expenses);
      setApr_amount_sum(parsedData.apr_amount_sum);
      setApr_balance_sum(parsedData.apr_balance_sum);
      setRejectExpenseList(parsedData.Rejected_Expenses);
      setRej_amount_sum(parsedData.rej_amount_sum);
      setRej_balance_sum(parsedData.rej_balance_sum);
      setDisburseExpenseList(parsedData.Disbursed_Expenses);
      setDis_amount_sum(parsedData.dis_amount_sum);
      setDis_balance_sum(parsedData.dis_balance_sum);
      return;
    }

    const raw = new FormData();
    raw.append("which", "other");
    raw.append("start_date", "");
    raw.append("end_date", "");
    raw.append("society_id", society_id);

    try {
      const response = await api.post("/account/expense/list", raw, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      });

      const data = response.data;

      localStorage.setItem("expensesData", JSON.stringify(data));

      setRequestExpenseList(data?.Requested_Expenses);
      setReg_amount_sum(data?.reg_amount_sum);
      setReg_balance_sum(data?.reg_balance_sum);
      setRecommendedExpenseList(data?.Recommended_Expenses);
      setRec_amount_sum(data?.rec_amount_sum);
      setRec_balance_sum(data?.rec_balance_sum);
      setApproveExpenseList(data?.Approved_Expenses);
      setApr_amount_sum(data?.apr_amount_sum);
      setApr_balance_sum(data?.apr_balance_sum);
      setRejectExpenseList(data?.Rejected_Expenses);
      setRej_amount_sum(data?.rej_amount_sum);
      setRej_balance_sum(data?.rej_balance_sum);
      setDisburseExpenseList(data?.Disbursed_Expenses);
      setDis_amount_sum(data?.dis_amount_sum);
      setDis_balance_sum(data?.dis_balance_sum);
    } catch (error) {
      console.log(error);
    } finally {
      setStart_date_req("");
      setEnd_date_req("");
      setStart_date_apr("");
      setEnd_date_apr("");
      setStart_date_dis("");
      setEnd_date_dis("");
      setStart_date_rej("");
      setEnd_date_rej("");
    }
  };

  const fetchExpenses_req_filterd = () => {
    const req_pack = new FormData();
    req_pack.append("which", "request");
    req_pack.append("start_date", start_date_req);
    req_pack.append("end_date", end_date_req);
    api
      .post("/account/expense/list", req_pack, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setRequestExpenseList(response.data?.Requested_Expenses);
        setReg_amount_sum(response.data?.reg_amount_sum);
        setReg_balance_sum(response.data?.reg_balance_sum);

        setRecommendedExpenseList(response.data?.Recommended_Expenses);
        setRec_amount_sum(response.data?.rec_amount_sum);
        setRec_balance_sum(response.data?.rec_balance_sum);

        setApproveExpenseList(response.data?.Approved_Expenses);
        setApr_amount_sum(response.data?.apr_amount_sum);
        setApr_balance_sum(response.data?.apr_balance_sum);

        setRejectExpenseList(response.data?.Rejected_Expenses);
        setRej_amount_sum(response.data?.rej_amount_sum);
        setRej_balance_sum(response.data?.rej_balance_sum);

        setDisburseExpenseList(response.data?.Disbursed_Expenses);
        setDis_amount_sum(response.data?.dis_amount_sum);
        setDis_balance_sum(response.data?.dis_balance_sum);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchRecommended_rec_filterd = () => {
    const rec_pack = new FormData();
    rec_pack.append("which", "recommendation");
    rec_pack.append("start_date", start_date_rec);
    rec_pack.append("end_date", end_date_rec);
    api
      .post("/account/expense/list", rec_pack, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setRequestExpenseList(response.data?.Requested_Expenses);
        setReg_amount_sum(response.data?.reg_amount_sum);
        setReg_balance_sum(response.data?.reg_balance_sum);

        setRecommendedExpenseList(response.data?.Recommended_Expenses);
        setRec_amount_sum(response.data?.rec_amount_sum);
        setRec_balance_sum(response.data?.rec_balance_sum);

        setApproveExpenseList(response.data?.Approved_Expenses);
        setApr_amount_sum(response.data?.apr_amount_sum);
        setApr_balance_sum(response.data?.apr_balance_sum);

        setRejectExpenseList(response.data?.Rejected_Expenses);
        setRej_amount_sum(response.data?.rej_amount_sum);
        setRej_balance_sum(response.data?.rej_balance_sum);

        setDisburseExpenseList(response.data?.Disbursed_Expenses);
        setDis_amount_sum(response.data?.dis_amount_sum);
        setDis_balance_sum(response.data?.dis_balance_sum);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchExpenses_apr_filterd = () => {
    const apr_pack = new FormData();
    apr_pack.append("which", "approval");
    apr_pack.append("start_date", start_date_apr);
    apr_pack.append("end_date", end_date_apr);
    api
      .post("/account/expense/list", apr_pack, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setRequestExpenseList(response.data?.Requested_Expenses);
        setReg_amount_sum(response.data?.reg_amount_sum);
        setReg_balance_sum(response.data?.reg_balance_sum);

        setRecommendedExpenseList(response.data?.Recommended_Expenses);
        setRec_amount_sum(response.data?.rec_amount_sum);
        setRec_balance_sum(response.data?.rec_balance_sum);

        setApproveExpenseList(response.data?.Approved_Expenses);
        setApr_amount_sum(response.data?.apr_amount_sum);
        setApr_balance_sum(response.data?.apr_balance_sum);

        setRejectExpenseList(response.data?.Rejected_Expenses);
        setRej_amount_sum(response.data?.rej_amount_sum);
        setRej_balance_sum(response.data?.rej_balance_sum);

        setDisburseExpenseList(response.data?.Disbursed_Expenses);
        setDis_amount_sum(response.data?.dis_amount_sum);
        setDis_balance_sum(response.data?.dis_balance_sum);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchExpenses_dis_filterd = () => {
    const dis_pack = new FormData();
    dis_pack.append("which", "disburse");
    dis_pack.append("start_date", start_date_dis);
    dis_pack.append("end_date", end_date_dis);
    api
      .post("/account/expense/list", dis_pack, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setRequestExpenseList(response.data?.Requested_Expenses);
        setReg_amount_sum(response.data?.reg_amount_sum);
        setReg_balance_sum(response.data?.reg_balance_sum);

        setRecommendedExpenseList(response.data?.Recommended_Expenses);
        setRec_amount_sum(response.data?.rec_amount_sum);
        setRec_balance_sum(response.data?.rec_balance_sum);

        setApproveExpenseList(response.data?.Approved_Expenses);
        setApr_amount_sum(response.data?.apr_amount_sum);
        setApr_balance_sum(response.data?.apr_balance_sum);

        setRejectExpenseList(response.data?.Rejected_Expenses);
        setRej_amount_sum(response.data?.rej_amount_sum);
        setRej_balance_sum(response.data?.rej_balance_sum);

        setDisburseExpenseList(response.data?.Disbursed_Expenses);
        setDis_amount_sum(response.data?.dis_amount_sum);
        setDis_balance_sum(response.data?.dis_balance_sum);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchExpenses_rej_filterd = () => {
    const rej_pack = new FormData();
    rej_pack.append("which", "reject");
    rej_pack.append("start_date", start_date_rej);
    rej_pack.append("end_date", end_date_rej);
    api
      .post("/account/expense/list", rej_pack, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setRequestExpenseList(response.data?.Requested_Expenses);
        setReg_amount_sum(response.data?.reg_amount_sum);
        setReg_balance_sum(response.data?.reg_balance_sum);

        setRecommendedExpenseList(response.data?.Recommended_Expenses);
        setRec_amount_sum(response.data?.rec_amount_sum);
        setRec_balance_sum(response.data?.rec_balance_sum);

        setApproveExpenseList(response.data?.Approved_Expenses);
        setApr_amount_sum(response.data?.apr_amount_sum);
        setApr_balance_sum(response.data?.apr_balance_sum);

        setRejectExpenseList(response.data?.Rejected_Expenses);
        setRej_amount_sum(response.data?.rej_amount_sum);
        setRej_balance_sum(response.data?.rej_balance_sum);

        setDisburseExpenseList(response.data?.Disbursed_Expenses);
        setDis_amount_sum(response.data?.dis_amount_sum);
        setDis_balance_sum(response.data?.dis_balance_sum);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  

  const [finish, setfinish] = useState(false);
  const handleSeeMessage = (
    message,
    amount,
    narration,
    transaction_id,
    reco,
    ledger
  ) => {
    setIdd(transaction_id);
    setAmountt(amount);
    setNaration(narration);
    setActionMessage(message);
    setNote(true);
    setSee(false);
    setReco_amount(reco);
    setledger_name(ledger);
    setfinish(true);
  };

  

  const handleClosee = () => {
    setOpenn(false);
    setIdd();
    setNowAmount();
    setTransferDetails([]);
    setAccount_idd();
    setReco_amount();``
    setledger_name();
    setDisbures_date("");
  };
  const handleDisburse = (transaction_id, amount, reco, ledger) => {
    setOpenn(true);
    setIdd(transaction_id);
    setNowAmount(amount);
    setReco_amount(reco);
    setledger_name(ledger);
  };

  //   Delete Expense
  const handleDelete = (transaction_id) => {
    const id = new FormData();
    id.append("transaction_id", transaction_id);
    api
      .post("/account/request/delete", id, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchExpenses();
      });
  };

  const handleClosse = () => {
    setNote(false);
    setAmountt();
    setNaration();
    setActionMessage();
    setRejeect("");
  };

  const [rejeect, setRejeect] = useState("");

  const handelSetMessage = (event) => {
    event.preventDefault();
    const data = new FormData();
    data.append("transaction_id", idd);
    data.append("amount", reco_amount);
    data.append("actionMessage", actionMessage);
    data.append("reco", recom);
    if (rejeect === "reject") {
      api
        .post("/account/request/reject", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          setNote(false);
          setAmountt();
          setReco_amount();
          setledger_name();
          setNaration();
          setActionMessage();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          fetchExpenses();
        });
    } else {
      api
        .post("/account/request/approve", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          setNote(false);
          setAmountt();
          setReco_amount();
          setledger_name();
          setNaration();
          setActionMessage();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          fetchExpenses();
        });
    }
  };
  // Approve Expense
  const handleApprove = (
    transaction_id,
    amount,
    narration,
    recommended_amount,
    ledger,
    message
  ) => {
    const id = new FormData();
    id.append("transaction_id", transaction_id);
    setIdd(transaction_id);
    setAmountt(amount);
    setNaration(narration);
    setNote(true);
    setRejeect("approve");
    setReco_amount(recommended_amount);
    setledger_name(ledger);
    setRecom("requ");
    setActionMessage(message);
  };

  const handleApproveMend = (
    transaction_id,
    amount,
    narration,
    recommended_amount,
    ledger
  ) => {
    const id = new FormData();
    id.append("transaction_id", transaction_id);
    setIdd(transaction_id);
    setAmountt(amount);
    setNaration(narration);
    setNote(true);
    setRejeect("approve");
    setReco_amount(recommended_amount);
    setledger_name(ledger);
    setRecom("reco");
  };
  // Disapprove
  const handleDisApprove = (transaction_id) => {
    const id = new FormData();
    id.append("transaction_id", transaction_id);
    api
      .post("/account/request/disapprove", id, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchExpenses();
      });
  };
  // Reject
  const handleReject = (transaction_id, amount, narration) => {
    setIdd(transaction_id);
    setAmountt(amount);
    setNaration(narration);
    setNote(true);
    setRejeect("reject");
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 720,
    maxHeight: "90vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const handleSocietyBanks = () => {
    api
      .get(`/account/society/all/${society_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAccounts(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const handleDisburseConfirmation = (type, account_id) => {
    const data = new FormData();
    data.append("transaction_id", idd);
    if(type === 'ecash'){
      data.append("ecash_id", account_id);
      setEcash(true)
    }
    if(type === 'bank'){
      data.append("bank_id", account_id);
      setEcash(false)
    }
    setAccount_idd(account_id);


    api
      .post("/account/payment/details", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setTransferDetails(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleConfirmDisburse = () => {
    const data = new FormData();
    data.append("transaction_id", idd);
    if(ecash){
      data.append("ecash_id", account_idd);
    }
    if(!ecash){
      data.append("bank_id", account_idd);
    }
    data.append("disbures_date", disbures_date);

    toast.promise(
      api
      .post("/account/disburse/funds", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: 'Disbursing funds...',
        success: (response) => {
          handleClosee();
          fetchExpenses();
          
          return response.data
        },
        error: (error) => {
          console.log(error);
          
          return "An error occurred, Try Again"
        }
      }
    )
  };

  const [ole, setOle] = useState(recom === "reco" ? true : false);

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 5 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header title="Expenses" />
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <Typography sx={{m:1, textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h3">
                <b>{society_name}</b>
              </Typography>
            </Grid>
            {permissions && permissions.view_requested_expense === true ? (
            <Grid item xs={12} md={12}>
              <Item>
                <Typography sx={{m:1, textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h4">
                  <b>Requested Funds</b>
                </Typography>
                <div style={{ display: "flex", margin:1 }}>
                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    helperText="From"
                    name="start_date_req"
                    onChange={(e) => setStart_date_req(e.target.value)}
                    value={start_date_req}
                    sx={{ mr: 1 }}
                  />

                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    helperText="To"
                    name="end_date_req"
                    onChange={(e) => setEnd_date_req(e.target.value)}
                    value={end_date_req}
                    sx={{ mr: 1 }}
                  />

                  <IconButton onClick={fetchExpenses_req_filterd}>
                    <FilterAltOutlinedIcon />
                  </IconButton>
                  <IconButton onClick={fetchExpenses}>
                    <CancelIcon />
                  </IconButton>
                </div>
                <Divider variant="middle" />
                  <Box
                    sx={{
                      overflow: "auto",
                      marginBottom: 10,
                      maxHeight: 340,
                      "&::-webkit-scrollbar": {
                        width: "7px",
                        height: "7px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#555",
                      },
                    }}
                  >
                    <Table size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>No.</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>User Name</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Request Date</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Amount Requested</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Amount Recommended</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Request Details</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Role</b>
                            </Typography>{" "}
                          </TableCell>
                          {permissions && permissions.recommend_expense === true ? (
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Recommend</b>
                            </Typography>{" "}
                          </TableCell>
                          ):null}
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Reject Request</b>
                            </Typography>{" "}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {requestExpenseList?.map((row, index) => (
                          <TableRow
                            key={row.id}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                              backgroundColor: "#f5f3f4",
                            }}
                          >
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{index + 1}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{`${row.firstName} ${row.lastName}`}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{formatDateToYearMonthDay(new Date(row.request_date))}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(row.amount)}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(row.recommended_amount)}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.narration}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.role_name}</b>
                              </Typography>
                            </TableCell>
                            {permissions && permissions.recommend_expense === true ? (
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                  size="small"
                                  color="success"
                                  variant="contained"
                                  sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() => handleApproveMend(
                                    row.transaction_id,
                                    row.amount,
                                    row.narration,
                                    row.recommended_amount,
                                    row.account_name
                                  )}
                                >
                                  <FolderSharedRoundedIcon />
                                </Button>
                              </Typography>
                            </TableCell>
                            ):null}
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <Button
                                size="small"
                                color="error"
                                variant="contained"
                                sx={{
                                  borderRadius: 2,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                  },
                                }}
                                onClick={() =>  handleReject(
                                  row.transaction_id,
                                  row.amount,
                                  row.narration
                                )}
                              >
                                <DeleteRoundedIcon />
                              </Button>
                            </Typography>
                          </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
              </Item>
            </Grid>
             ):null}
          {permissions && permissions.view_recommend_expense === true ? (
            <Grid item xs={12} md={12}>
              <Item>
                <Typography sx={{m:1, textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h4">
                  <b>Recommended Requests</b>
                </Typography>
                <div style={{ display: "flex", margin:1, margin:1 }}>
                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    helperText="From"
                    name="start_date_req"
                    onChange={(e) => setStart_date_rec(e.target.value)}
                    value={start_date_req}
                    sx={{ mr: 1 }}
                  />

                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    helperText="To"
                    name="end_date_req"
                    onChange={(e) => setEnd_date_rec(e.target.value)}
                    value={end_date_req}
                    sx={{ mr: 1 }}
                  />

                  <IconButton onClick={fetchExpenses_apr_filterd}>
                    <FilterAltOutlinedIcon />
                  </IconButton>
                  <IconButton onClick={fetchExpenses}>
                    <CancelIcon />
                  </IconButton>
                </div>
                <Divider variant="middle" />
                  <Box
                    sx={{
                      overflow: "auto",
                      marginBottom: 10,
                      maxHeight: 340,
                      "&::-webkit-scrollbar": {
                        width: "7px",
                        height: "7px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#555",
                      },
                    }}
                  >
                    <Table size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>No.</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>User Name</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Request Date</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Amount Requested</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Amount Recommended</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Request Details</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Role</b>
                            </Typography>{" "}
                          </TableCell>
                          {permissions && permissions.approved_expense === true ? (
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Approve</b>
                            </Typography>{" "}
                          </TableCell>
                          ):null}
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Reject Request</b>
                            </Typography>{" "}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {recommendedExpenseList?.map((row, index) => (
                          <TableRow
                            key={row.id}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                              backgroundColor: "#f5f3f4",
                            }}
                          >
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{index + 1}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{`${row.firstName} ${row.lastName}`}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{formatDateToYearMonthDay(new Date(row.request_date))}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(row.amount)}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(row.recommended_amount)}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.narration}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.role_name}</b>
                              </Typography>
                            </TableCell>
                            {permissions && permissions.approved_expense === true ? (
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                  size="small"
                                  color="success"
                                  variant="contained"
                                  sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() => handleApprove(
                                    row.transaction_id,
                                    row.amount,
                                    row.narration,
                                    row.recommended_amount,
                                    row.account_name,
                                    row.message,
                                  )}
                                >
                                  <FolderSharedRoundedIcon />
                                </Button>
                              </Typography>
                            </TableCell>
                            ):null}
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <Button
                                size="small"
                                color="error"
                                variant="contained"
                                sx={{
                                  borderRadius: 2,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                  },
                                }}
                                onClick={() =>  handleReject(
                                  row.transaction_id,
                                  row.amount,
                                  row.narration
                                )}
                              >
                                <DeleteRoundedIcon />
                              </Button>
                            </Typography>
                          </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
              </Item>
            </Grid>
             ):null}




             

            {permissions && permissions.view_approved_expense === true ? (
            <Grid item xs={12} md={12}>
              <Item>
                <Typography sx={{m:1, textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h4">
                  <b>Approved Funds</b>
                </Typography>
                <div style={{ display: "flex", margin:1 }}>
                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    helperText="From"
                    name="start_date_apr"
                    onChange={(e) => setStart_date_apr(e.target.value)}
                    value={start_date_apr}
                    sx={{ mr: 1 }}
                  />

                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    helperText="To"
                    name="end_date_apr"
                    onChange={(e) => setEnd_date_apr(e.target.value)}
                    value={end_date_apr}
                    sx={{ mr: 1 }}
                  />

                  <IconButton onClick={fetchExpenses_apr_filterd}>
                    <FilterAltOutlinedIcon />
                  </IconButton>
                  <IconButton onClick={fetchExpenses}>
                    <CancelIcon />
                  </IconButton>
                </div>
                <Divider variant="middle" />
                  <Box
                    sx={{
                      overflow: "auto",
                      marginBottom: 10,
                      maxHeight: 340,
                      "&::-webkit-scrollbar": {
                        width: "7px",
                        height: "7px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#555",
                      },
                    }}
                  >
                    <Table size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>No.</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>User Name</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Request Date</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Amount Requested</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Amount Recommended</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Approval Message</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Role</b>
                            </Typography>{" "}
                          </TableCell>
                          {permissions && permissions.disburse_expense === true ? (
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Disburse</b>
                            </Typography>{" "}
                          </TableCell>
                          ):null}
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>View</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Disapprove</b>
                            </Typography>{" "}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {approveExpenseList?.map((row, index) => (
                          <TableRow
                            key={row.id}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                              backgroundColor: "#f5f3f4",
                            }}
                          >
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{index + 1}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{`${row.firstName} ${row.lastName}`}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{formatDateToYearMonthDay(new Date(row.request_date))}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(row.amount)}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(row.recommended_amount)}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.message}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.role_name}</b>
                              </Typography>
                            </TableCell>
                            {permissions && permissions.disburse_expense === true ? (
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                  size="small"
                                  color="success"
                                  variant="contained"
                                  sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() => handleDisburse(
                                    row.transaction_id,
                                    row.amount,
                                    row.recommended_amount,
                                    row.account_name
                                  )}
                                >
                                  <FolderSharedRoundedIcon />
                                </Button>
                              </Typography>
                            </TableCell>
                            ):null}
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                  size="small"
                                  color="success"
                                  variant="contained"
                                  sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() => handleSeeMessage(
                                    row.message,
                                    row.amount,
                                    row.narration,
                                    row.transaction_id
                                  )}
                                >
                                  <FolderSharedRoundedIcon />
                                </Button>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <Button
                                size="small"
                                color="error"
                                variant="contained"
                                sx={{
                                  borderRadius: 2,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                  },
                                }}
                                onClick={() =>  handleDisApprove(row.transaction_id)}
                              >
                                <DeleteRoundedIcon />
                              </Button>
                            </Typography>
                          </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
              </Item>
            </Grid>
            ):null}


        {permissions && permissions.view_disburse_expense === true ? (
            <Grid item xs={12} md={12}>
              <Item>
                <Typography sx={{m:1, textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h4">
                  <b>Disbursed Funds</b>
                </Typography>

                <div style={{ display: "flex", margin:1 }}>
                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    helperText="From"
                    name="start_date_dis"
                    onChange={(e) => setStart_date_dis(e.target.value)}
                    value={start_date_dis}
                    sx={{ mr: 1 }}
                  />

                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    helperText="To"
                    name="end_date_dis"
                    onChange={(e) => setEnd_date_dis(e.target.value)}
                    value={end_date_dis}
                    sx={{ mr: 1 }}
                  />

                  <IconButton onClick={fetchExpenses_dis_filterd}>
                    <FilterAltOutlinedIcon />
                  </IconButton>
                  <IconButton onClick={fetchExpenses}>
                    <CancelIcon />
                  </IconButton>
                </div>
                <Divider variant="middle" />
                  <Box
                    sx={{
                      overflow: "auto",
                      marginBottom: 10,
                      maxHeight: 340,
                      "&::-webkit-scrollbar": {
                        width: "7px",
                        height: "7px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#555",
                      },
                    }}
                  >
                    <Table size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>No.</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>User Name</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Disburse Date</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Amount Requested</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Amount Recommended</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Approval Message</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Role</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Disbures date</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>View</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Delete</b>
                            </Typography>{" "}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {disburseExpenseList?.map((row, index) => (
                          <TableRow
                            key={row.id}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                              backgroundColor: "#f5f3f4",
                            }}
                          >
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{index + 1}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{`${row.firstName} ${row.lastName}`}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{formatDateToYearMonthDay(new Date(row.disbures_date))}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(row.amount)}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(row.recommended_amount)}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.message}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.role_name}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography disabled={permissions && permissions.id !== 1} onClick={() => changeDate(row.transaction_id)} sx={{ color:'blue', cursor:'pointer' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Edit</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                  size="small"
                                  color="success"
                                  variant="contained"
                                  sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() => handleSeeMessage(
                                    row.message,
                                    row.amount,
                                    row.narration,
                                    row.transaction_id
                                  )}
                                >
                                  <FolderSharedRoundedIcon />
                                </Button>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <Button
                                size="small"
                                color="error"
                                variant="contained"
                                sx={{
                                  borderRadius: 2,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                  },
                                }}
                                onClick={() => handleDelete(row.transaction_id)}
                              >
                                <DeleteRoundedIcon />
                              </Button>
                            </Typography>
                          </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
              </Item>
            </Grid>
            ):null}

            <Grid item xs={12} md={12}>
              <Item>
                <Typography sx={{m:1, textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h4">
                  <b>Rejected Requests</b>
                </Typography>
                
                <div style={{ display: "flex", margin:1 }}>
                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    helperText="From"
                    name="start_date_rej"
                    onChange={(e) => setStart_date_rej(e.target.value)}
                    value={start_date_rej}
                    sx={{ mr: 1 }}
                  />

                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    helperText="To"
                    name="end_date_rej"
                    onChange={(e) => setEnd_date_rej(e.target.value)}
                    value={end_date_rej}
                    sx={{ mr: 1 }}
                  />

                  <IconButton onClick={fetchExpenses_rej_filterd}>
                    <FilterAltOutlinedIcon />
                  </IconButton>
                  <IconButton onClick={fetchExpenses}>
                    <CancelIcon />
                  </IconButton>
                </div>
                <Divider variant="middle" />
                  <Box
                    sx={{
                      overflow: "auto",
                      marginBottom: 10,
                      maxHeight: 340,
                      "&::-webkit-scrollbar": {
                        width: "7px",
                        height: "7px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#555",
                      },
                    }}
                  >
                    <Table size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>No.</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>User Name</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Request Date</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Amount Requested</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Amount Recommended</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Request Details</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Role</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Undo</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Message</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Delete</b>
                            </Typography>{" "}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rejectExpenseList?.map((row, index) => (
                          <TableRow
                            key={row.id}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                              backgroundColor: "#f5f3f4",
                            }}
                          >
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{index + 1}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{`${row.firstName} ${row.lastName}`}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{formatDateToYearMonthDay(new Date(row.request_date))}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(row.amount)}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(row.recommended_amount)}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.narration}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.role_name}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                  size="small"
                                  color="success"
                                  variant="contained"
                                  sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() =>  handleDisApprove(row.transaction_id)}
                                >
                                  <FolderSharedRoundedIcon />
                                </Button>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                  size="small"
                                  color="success"
                                  variant="contained"
                                  sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() => handleSeeMessage(
                                    row.message,
                                    row.amount,
                                    row.narration,
                                    row.transaction_id
                                  )}
                                >
                                  <FolderSharedRoundedIcon />
                                </Button>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <Button
                                size="small"
                                color="error"
                                variant="contained"
                                sx={{
                                  borderRadius: 2,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                  },
                                }}
                                onClick={() => handleDelete(row.transaction_id)}
                              >
                                <DeleteRoundedIcon />
                              </Button>
                            </Typography>
                          </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
              </Item>
            </Grid>
          </Grid>

          <Modal
            open={openn}
            onClose={handleClosee}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h4">
                    <b>Disburse Funds</b>
                  </Typography>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Box sx={{ m: 2, display: "block" }}>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>
                        Requested Amount: {currencyFormat.format(nowAmount)}
                      </b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>
                        Recommended Amount:{" "}
                        {currencyFormat.format(reco_amount ? reco_amount : 0)}
                      </b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>
                        Approved Amount:{" "}
                        {currencyFormat.format(
                          reco_amount || reco_amount > 0
                            ? reco_amount
                            : nowAmount
                        )}
                      </b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Ledger Selected: {ledger_name}</b>
                    </Typography>
                      
                    <TextField
                        size="small"
                        helperText="Disbures date"
                        variant="outlined"
                        name="date"
                        disabled={permissions && permissions.id !== 1}
                        sx={{ mb: 2 }}
                        value={disbures_date}
                        onChange={(e) => setDisbures_date(e.target.value)}
                        type='datetime-local'
                      />
                  </Box>
                </Grid>
                {accounts?.Accounts ? (
                  <Grid item xs={12} md={12}>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: "center" }}>
                     <b>{society_name}</b>
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      sx={{
                        textAlign: "center",
                        my: 2,
                      }}
                    >
                      <b>Select account to disburse funds from</b>
                    </Typography>
                    <Item>
                        <Chip
                          disabled={
                            (
                              reco_amount || reco_amount > 0
                                ? reco_amount < accounts?.Main?.current_balance
                                : nowAmount < accounts?.Main?.current_balance
                            )
                              ? false
                              : true
                          }
                          label={`Main Wallet Account ==> ${currencyFormat.format(accounts?.Main?.current_balance)}`}
                          onClick={() => handleDisburseConfirmation('ecash', accounts?.Main?.id)}
                          variant="outlined"
                          color="success"
                          style={{ margin: "4px" }}
                        />
                        
                        <Divider sx={{my:1}} variant="middle">
                          <Typography
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Other Accounts</b>
                          </Typography>
                        </Divider>
                      <div style={{ display: "flex", margin:1, flexWrap: "wrap" }}>
                        {accounts?.Accounts?.map((item) => (
                          <Chip
                            disabled={
                              (
                                reco_amount || reco_amount > 0
                                  ? reco_amount < item.current_balance
                                  : nowAmount < item.current_balance
                              )
                                ? false
                                : true
                            }
                            key={item.id}
                            label={`${item.account_name} ${currencyFormat.format(item.current_balance)}`}
                            onClick={() => handleDisburseConfirmation('bank', item.id)}
                            variant="outlined"
                            color="success"
                            style={{ margin: "4px" }}
                          />
                        ))}
                      </div>
                    </Item>
                  </Grid>
                ) : null}
                {transferDetails.Bank_Account_Name ? (
                  <Grid item xs={12} md={12}>
                    <Iteme>
                      <Typography sx={{ color: "black" }}>
                        Account: {transferDetails.Bank_Account_Name}
                      </Typography>

                      <Typography sx={{ color: "black" }}>
                        Receiver Name: {transferDetails.Funds_Reciever}
                      </Typography>

                      <Typography sx={{ color: "black" }}>
                        Reason for funding: {transferDetails.Reason_For_Funds}
                      </Typography>

                      <Typography sx={{ color: "black" }}>
                        Requested:{" "}
                        {moment(transferDetails.Request_Date).fromNow()}
                      </Typography>

                      <Typography sx={{ color: "black" }}>
                        Receiver Role: {transferDetails.Reciever_Role}
                      </Typography>

                      <Typography sx={{ color: "black" }}>
                        Receiver Email: {transferDetails.Reciever_Email}
                      </Typography>

                      <Typography sx={{ color: "black" }}>
                        Amount Requested:{" "}
                        {currencyFormat.format(
                          transferDetails.Amount_Requesting
                        )}
                      </Typography>

                      <Typography sx={{ color: "black" }}>
                        Amount to be Disbursed:{" "}
                        {currencyFormat.format(
                          transferDetails.Amount_Disbursing
                        )}
                      </Typography>

                      <Typography sx={{ color: "black" }}>
                        Current bank Balance:{" "}
                        {currencyFormat.format(
                          transferDetails.Current_Bank_Amount
                        )}
                      </Typography>

                      <Typography sx={{ color: "black" }}>
                        Balance after disbursement:{" "}
                        {currencyFormat.format(
                          transferDetails.Amount_After_Disbursement
                        )}
                      </Typography>
                    </Iteme>
                  </Grid>
                ) : null}

                <Grid item xs={12} md={12}>
                  <Button
                    sx={{ mr: 1 }}
                    disabled={transferDetails.Bank_Account_Name ? false : true}
                    variant="contained"
                    color="success"
                    startIcon={<Send />}
                    onClick={() => handleConfirmDisburse()}
                  >
                    Confirm Disburse
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    startIcon={<Cancel />}
                    onClick={handleClosee}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Modal>
          <Dialog open={note} onClose={handleClosse}>
            <form onSubmit={handelSetMessage}>
              <DialogTitle>Message for Action</DialogTitle>
              <DialogActions
                sx={{ display: "flex", justifyContent: "space-around" }}
              >
                <Typography variant="h5">Recommend Amount</Typography>
                <label class="switch">
                  <input
                    type="checkbox"
                    id="ole"
                    name="ole"
                    value={ole}
                    checked={ole}
                    onChange={(e) => setOle(e.target.checked)}
                  />
                  <span class="slider"></span>
                </label>
              </DialogActions>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Box sx={{ m: 2, display: "block" }}>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>
                          Requested Amount: {currencyFormat.format(amountt)}
                        </b>
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>
                          Recommended Amount:{" "}
                          {currencyFormat.format(reco_amount ? reco_amount : 0)}
                        </b>
                      </Typography>
                      {finish === true ? (
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>
                            Approved Amount:{" "}
                            {currencyFormat.format(
                              reco_amount ? reco_amount : amountt
                            )}
                          </b>
                        </Typography>
                      ) : null}
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Ledger Selected: {ledger_name}</b>
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      autoFocus
                      margin="dense"
                      disabled={ole === false ? true : false}
                      id="reco_amount"
                      name="reco_amount"
                      label="Recommend Amount(GHS)"
                      type="text"
                      onChange={(e) => setReco_amount(e.target.value)}
                      value={reco_amount}
                      fullWidth
                      variant="standard"
                    />
                  </Grid>
                </Grid>
                <TextField
                  autoFocus
                  margin="dense"
                  id="actionMessage"
                  name="actionMessage"
                  label="Message for Action"
                  type="text"
                  fullWidth
                  sx={{ marginBottom: 2 }}
                  variant="outlined"
                  multiline
                  rows={4}
                  value={actionMessage}
                  onChange={(e) => setActionMessage(e.target.value)}
                />
              </DialogContent>
              <DialogActions
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Button
                  onClick={handleClosse}
                  variant="contained"
                  color="error"
                >
                  Cancel
                </Button>
                <Fab
                  disabled={see ? false : true}
                  component="button"
                  type="submit"
                  color="success"
                  size="medium"
                  aria-label="add"
                >
                  <SendIcon />
                </Fab>
              </DialogActions>
            </form>
          </Dialog>

          <Modal
              open={openDate}
              onClose={closeDate}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
          >
            <Box sx={style1}>
              <Typography sx={{ textAlign:'center' }} variant="h3" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>New Disbures Date</b>
              </Typography>

              <TextField
                size="small"
                variant="outlined"
                name="newDate"
                sx={{ m: 2 }}
                value={newDate}
                onChange={(e) => setNewDate(e.target.value)}
                type='datetime-local'
              />

            <Box sx={{ display:'flex', flexDirection:'row' }}>
              <Button
                size="small"
                color="error"
                variant="contained"
                sx={{
                borderRadius: 2,
                m: 1,
                boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                    boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "#14213d",
                },
                }}
                onClick={closeDate}
              >
                  Cancel
              </Button>

              <Button
                size="small"
                color="success"
                variant="contained"
                sx={{
                borderRadius: 2,
                m: 1,
                boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                    boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "#14213d",
                },
                }}
                onClick={editDisbureseDate}
              >
                Edit Date
              </Button>
            </Box>
            </Box>
            </Modal>
        </Box>
      </main>
    </div>
  );
};

export default Expenses;
